export const gallerySectionCommercialInteriorPainting =
{
  "title": "Explore Our Work",
  "columns": 3,
  "rowHeight": 1200,
  "pageSize": 9,
  "images": [
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/1.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/2.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/3.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/4.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/5.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/6.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/7.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/8.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/9.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/10.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/11.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/12.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/13.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/14.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/15.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/16.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/17.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/18.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/19.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/20.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/21.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/22.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/23.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/24.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/25.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0005CommercialInteriorPainting/26.jpg", "rowSpan": 1, "colSpan": 2 }
  ]

}